<template>
  <div class="basic">
    <el-form>
      <el-form-item>
        <label>What's the name of your marketplace? *
          <select
            v-model="selectedMarketplace"
            required="true"
            class="el-input__inner"
          >
            <option
              disabled
              value=""
            >
              Please select the country
            </option>
            <option value="GLOBAL">Docplanner General</option>
            <option value="PL">ZnanyLekarz Poland</option>
            <option value="IT">Miodottore Italy</option>
            <option value="TR">DoktorTakvimi Turkey</option>
            <option value="ES">Doctoralia Spain</option>
            <option value="BR">Doctoralia Brazil</option>
            <option value="MX">Doctoralia Mexico</option>
            <option value="AR">Doctoralia Argentina</option>
            <option value="CO">Doctoralia Colombia</option>
            <option value="CL">Doctoralia Chile</option>
            <option value="PE">Doctoralia Peru</option>
            <option value="CZ">ZnamyLekar Czechia</option>
          </select>
        </label>
      </el-form-item>
      <el-form-item>
        <div class="image-preview-wrapper">
          <div
            class="image-preview"
            :style="{'background-image': `url(${imageUrl})` }"
          />
          <div class="image-preview__actions">
            <upload
              :crop-width="200"
              :crop-height="200"
              @upload="onUpload"
            />
            <el-row :gutter="20">
              <el-col :span="16">
                <el-input
                  v-model="imageUrl"
                  placeholder="http://"
                  clearable
                  @clear="onClearImageLink"
                />
              </el-col>
              <el-col :span="8">
                <el-button @click="onAddLink">
                  Add link
                </el-button>
              </el-col>
            </el-row>
            <div class="desc">
              <p>You can upload image or add the public link to image.</p>
            </div>
          </div>
        </div>
      </el-form-item>
      
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in basic.fields"
          :key="item.id"
          :span="24"
        >
          <field-item
            :is-addon-field="index > 5"
            :index="index"
          />
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { guid } from '../util/helpers'
import FieldItem from './FieldItem'
import Upload from '@/components/Upload'

export default {
  name: 'Basic',

  components: {
    FieldItem,
    Upload
  },

  data () {
    return {
      fieldName: '',
      filedValue: '',
      filedType: 'text',
      imageLink: '',
      showDialog: false,
      showAlert: false,
      checked: false
    }
  }, 
  computed: {
    ...mapState(['attributes', 'basic', 'marketplaces']),
    imageUrl: {
      get () {
        return this.basic.image.link
      },
      set (v) {
        this.$store.dispatch('updateImage', { link: v })
      }
    },
    selectedMarketplace: {
      get () {
        return this.basic.marketplace.country
      },
      set (v) {
        this.$store.dispatch('selectMarketplace', { country: v })
      }
    }
  },

  created () {
    this.$ga.page(this.$router)
  },

  methods: {
    addField () {
      const newFiled = {
        name: this.fieldName,
        value: this.filedValue,
        type: this.filedType,
        id: guid()
      }

      this.$store.dispatch('addField', newFiled)
      this.fieldName = ''
      this.filedValue = ''
      this.showDialog = false
    },
    onAddField () {
      this.showDialog = true
      this.$nextTick(() => {
        this.$refs.fieldName.focus()
      })
    },
    onAddLink () {
      this.$store.dispatch('updateImage', { link: this.imageUrl })
    },
    onClearImageLink () {
      this.imageLink = ''
      this.onAddLink()
    },
    onUpload (url) {
      this.$store.dispatch('updateImage', { link: url })
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';

  label{
    display:flex;
    flex-direction:column;
  }
.image-preview-wrapper {
  display: flex;
  margin-top: 20px;
  .image-preview {
    margin-right: 30px;
    width: 60px;
    height: 60px;
    background-color: #eee;
    background-size: 60px;
    background-position: center center;
    background-size: cover;
    flex-shrink: 0;
    overflow: hidden;
    &__actions {
      width: 100%;
      .upload {
        margin-bottom: 20px;
      }
    }
  }
  .remove-image {
    padding: 10px;
    cursor: pointer;
    &:hover {
      i {
        color: #909399;
      }
    }
    i {
      color: #c0c4cc;
    }
  }

  .el-button {
    height: 40px;
  }
  .el-upload {
    display: inline-block;
    margin-bottom: 20px;
  }
}
.remove-field {
  display: inline-block;
  cursor: pointer;
}
.edit {
  i {
    color: $color-primary;
  }
  &:hover {
    i {
      color: darken($color-primary, 20%);
    }
  }
}
.delete {
  i {
    color: red;
  }
  &:hover {
    i {
      color: darken(red, 20%);
    }
  }
}
.image-tips {
  border-bottom: 1px dashed;
  .el-popover__reference {
    cursor: pointer;
  }
}
.el-col.el-col-24:nth-child(3),.el-col.el-col-24:nth-child(4){
  width:50%;
}
</style>
